import api from "./api";

const packageData = (data) => {
  const form = new FormData();

  for (const key in data) {
    if (Array.isArray(data[key])) {
      data[key].forEach((item, index) => {
        form.append(`${key}[${index}]`, item);
      });
    } else {
      form.append(key, data[key]);
    }
  }

  return form;
};

const requests = {
  // AUTH
  authPassword: (data) => api.post("/clients/login-register", data),
  authLogin: (data) => api.post("/clients/verify", data),
  getMe: () => api.get("/users/me"),
  updateProfile: (params) => api.patch("/users/me", packageData(params)),
  // PRODUCT
  fetchProducts: (params) => api.get("/products", { params }),
  fetchProductsStream: (params) =>
    api.get("/products?filters[in_stream]=true", { params }),
  fetchProductOne: (id) => api.get(`/products/${id}`),
  // ORDER
  createOrder: (params) => api.post("/orders/quick", params),
  updateOrderNew: (id) => api.post(`/orders/${id}/recheck`),
  orderChartStreamState: (id) => api.get(`/orders/stream-income/${id}`),
  orderUpdatePending: (id) => api.put(`/orders/${id}/pending`),
  // STREAM
  fetchStreamClent: (params) => api.get("/streams", { params }),
  fetchStreamStatistic: () => api.get("/streams/statistics"),
  fetchByStreamStatistic: (params) =>
    api.get("/streams/statistics/by-stream", { params }),
  createStream: (params) => api.post("/streams/join", params),
  deleteStream: (id) => api.delete(`/streams/${id}`),
  updateStreamAgent: (id, data) => api.patch(`/streams/${id}`, data),
  // PAYMENT
  fetchPaymentRequest: () => api.get("/payment-requests"),
  createPaymentRequest: (params) => api.post("/payment-requests", params),
  fetchTransactions: (params) => api.get("/transactions", { params }),
  // LOCATIONS
  getLocations: () => api.get("/regions"),
  fetchCatigory: () => api.get("/categories"),
  fetchProductWiew: () => api.get("/products/most/view/products"),
  fetchAgentOrders: (params) => api.get("/streams/orders", { params }),
  fetchBestSellingProduct: () => api.get("/orders/best/selling/products"),
  fetchContestState: () => api.get("/contest/state"),
  fetchContestParticipants: () => api.get("/contest/participants"),
  fetchContestJoin: () => api.post("/contest/join")
};

export default requests;
